import React from 'react';
import Icon from './Icon';
import { MODES, PREMIUM_BACKGROUNDS, FEMALE_CATEGORIES, MALE_CATEGORIES } from '../constants/mockupData';

interface MockupControlsProps {
    selectedMode: 'female' | 'male' | 'studio';
    setSelectedMode: (m: 'female' | 'male' | 'studio') => void;
    selectedCategory: string;
    setSelectedCategory: (c: string) => void;
    studioBg: string;
    setStudioBg: (s: string) => void;
    disabled: boolean;
}

const MockupControls: React.FC<MockupControlsProps> = ({
    selectedMode, setSelectedMode,
    selectedCategory, setSelectedCategory,
    studioBg, setStudioBg,
    disabled
}) => {
    const currentCategories = selectedMode === 'male' ? MALE_CATEGORIES : FEMALE_CATEGORIES;

    return (
        <div className="space-y-3">
            <div className="space-y-1.5">
                <p className="text-xs text-slate-400 uppercase tracking-widest font-black">Mode</p>
                <div className="grid grid-cols-3 gap-1 p-1 bg-slate-100 dark:bg-white/5 rounded-lg w-full">
                    {MODES.map(mode => (
                        <button
                            key={mode}
                            onClick={() => setSelectedMode(mode)}
                            disabled={disabled}
                            className={`h-8 rounded-md text-[10px] uppercase font-bold tracking-wider transition-all duration-300 flex items-center justify-center ${selectedMode === mode ? 'bg-white dark:bg-apple-gold text-slate-900 shadow-sm' : 'text-slate-400 hover:text-slate-600'}`}
                        >
                            {mode}
                        </button>
                    ))}
                </div>
            </div>

            {selectedMode === 'studio' && (
                <div className="space-y-1.5 animate-in fade-in slide-in-from-top-1 duration-300">
                    <label className="text-xs text-slate-400 uppercase tracking-widest font-black">Background</label>
                    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
                        {PREMIUM_BACKGROUNDS.map((bg) => (
                            <button
                                key={bg.id}
                                onClick={() => setStudioBg(bg.id)}
                                disabled={disabled}
                                className={`shrink-0 w-8 h-8 rounded-full border transition-all flex items-center justify-center ${studioBg === bg.id ? 'ring-2 ring-apple-gold border-transparent scale-110' : 'border-black/5 dark:border-white/5'}`}
                                style={{ backgroundColor: bg.color }}
                                title={bg.id}
                            />
                        ))}
                    </div>
                </div>
            )}

            <div className="space-y-1.5">
                <p className="text-xs text-slate-400 uppercase tracking-widest font-black">Category</p>
                <div className="grid grid-cols-2 gap-1.5">
                    {currentCategories.map((cat) => (
                        <button
                            key={cat.id}
                            onClick={() => setSelectedCategory(cat.id)}
                            disabled={disabled}
                            className={`py-2 px-1 rounded-lg text-[10px] uppercase tracking-wider font-bold transition-all border flex items-center justify-center break-words text-center leading-tight ${selectedCategory === cat.id ? 'bg-slate-900 dark:bg-white text-white dark:text-black border-transparent shadow-sm' : 'bg-white/50 dark:bg-white/5 text-slate-500 border-black/5 dark:border-white/10 hover:bg-white dark:hover:bg-white/10'}`}
                        >
                            {cat.label}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MockupControls;